
import Vue from 'vue';

export default Vue.extend({
  name: 'Slider',
  props: {
    items: Object as any,
  },
  data() {
    return {
      currentSlide: 0,
    };
  },
  methods: {
    setNext() {
      if (this.currentSlide + 1 < this.items.length) {
        this.currentSlide++;
      }
    },
    setPrev() {
      if (this.currentSlide > 0) {
        this.currentSlide--;
      }
    },
  },
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/info/components/block/components/slider/Slider.vue